export enum EnumLayoutRouter {
  首頁 = '/home',
  訂單下載 = '/OrderQuery',
  驗收單下載 = '/RcvQuery',
  退貨單下載 = '/RtnQuery',
}
export enum EnumAppRouter {
  登出頁 = '/logout',
  錯誤頁 = '/error',
  登入 = '/login',
  驗證頁 = '/auth',
  監控頁 = '/mon/service_mon',
  Line驗證頁 = '/auth_line',
}
